import React from 'react';
import _ from 'lodash';

export const sasaProductIds = [
  43623, 43392, 35904, 34906, 315, 2958, 14788, 18, 43568, 19, 13622, 275, 270,
  5781, 13622, 316, 43569, 38786, 2585, 413, 435, 464, 439, 20868, 438, 31083,
  13707, 615, 170, 19235, 193, 43571, 13587, 205, 1286, 34899, 27532, 35982,
  36202, 36379, 12442, 36672, 35219, 2687, 31080, 369, 380, 43574, 3120, 655,
  1417, 885, 43575, 34539, 730, 751, 832, 722, 841, 843, 3106, 2582, 36200,
  2727, 1620, 1612, 1620, 8187, 43576, 3150, 43577, 903, 35971, 983, 34951,
  36612, 2604, 8107, 2623, 43578, 2985, 2037, 2027, 2028, 43579, 43580, 2029,
  38526,
];

export const giftList = [
  {
    name: '雙人日本來回機票',
    scrollingName: '雙人東京來回\r\n經濟艙機票',
    fontSize: 20,
    subFontSize: 14,
    price: '價值HK$6,000',
    count: 1,
  },
  {
    name: 'GHD Platinum+ Styler (White)',
    scrollingName: 'GHD Platinum+ Styler\r\n(White)',
    fontSize: 14,
    subFontSize: 10,
    // subName: '光子嫩眼儀',
    price: '價值HK$2,395',
    count: 1,
  },
  {
    name: 'JUJY 雙頭全效全眼周\r\n逆齡聚能射頻美眼儀PRO 4.0',
    scrollingName: 'JUJY 雙頭全效全眼周逆齡聚能\r\n射頻美眼儀PRO 4.0',
    fontSize: 14,
    subFontSize: 10,
    price: '價值HK$2,097',
    count: 3,
  },
  {
    name: 'MOSCHINO Toy Pearl 淡香精 50ml',
    scrollingName: 'MOSCHINO Toy Pearl\r\n淡香精 50ml',
    price: '價值HK$630',
    count: 12,
  },
  {
    name: 'KÉRASTASE 逆時光至臻修護浴髮乳250ml',
    scrollingName: 'KÉRASTASE 逆時光至臻修護\r\n浴髮乳250ml',
    price: '價值HK$320',
    count: 50,
  },
  {
    name: 'VT 塗抹式膠原蛋白微針精華100 50ml',
    scrollingName: 'VT 塗抹式膠原蛋白\r\n微針精華100 50ml',
    price: '價值HK$378',
    count: 35,
  },
  {
    name: 'Cell Fusion 三文魚籽滋養精華安瓶 2mlx7支',
    scrollingName: 'Cell Fusion 三文魚籽滋養\r\n精華安瓶 2mlx7支',
    price: '價值HK$275',
    count: 35,
  },
  {
    name: 'LOREAL 活力緊緻 專研抗皺修護乳霜 50毫升',
    scrollingName: 'LOREAL 活力緊緻 專研\r\n抗皺修護乳霜 50毫升',
    price: '價值HK$249',
    count: 25,
  },
  {
    name: 'ANESSA 極防水美肌UV噴霧 SPF50+ PA++++ 60G',
    scrollingName: 'ANESSA 極防水美肌UV噴霧\r\nSPF50+ PA++++ 60G',
    price: '價值HK$159',
    count: 45,
  },
  {
    name: 'KANEBO 美妝套妝',
    scrollingName: 'KANEBO 美妝套妝',
    price: '價值約HK$178',
    count: 800,
  },
  {
    name: '莎莎VIP會藉1年',
    scrollingName: '莎莎VIP\r\n會藉1年',
    price: '',
    count: 1000,
  },
  {
    name: '莎莎$150-$35指定品牌優惠券',
    scrollingName: '莎莎$150-$35\r\n指定品牌優惠券',
    price: '價值HK$35',
    count: 5000,
  },
  {
    name: 'Sorra積分✦10至✦50不等',
    scrollingName: 'Sorra積分\r\n✦10至✦50不等',
    // subName: '入耳式耳機',
    price: '價值HK$10-$50',
    count: '人人有賞！',
  },
];

export const questions = [
  {
    name: '清潔與爽膚',
    tags: ['潔面卸妝', '爽膚'],
    // categories: [1, 2, 4],
  },
  {
    name: '修護與防曬',
    tags: ['精華', '乳液面霜', '面膜'],
    // categories: [3, 7, 14, 15],
  },
  {
    name: '底妝與修容',
    tags: ['防曬', '底妝'],
    // categories: [29, 32, 33, 43],
  },
  {
    name: '彩妝與香水',
    tags: ['眼妝', '唇頰彩妝', '香水'],
    // categories: [40, 45, 47],
  },
  {
    name: '您的出生年份是？',
    options: ['2000年或以後', '1990-1999 年', '1980-1989 年', '1979年或以前'],
  },
  {
    name: '您每月平均用於美妝產品\r\n（護膚+化妝）的預算範圍？',
    options: [
      '$500 以下',
      '$500 - $1,000',
      '$1,001 - $2,000',
      '$2,001 - $3,500',
      '$3,501 - $5,000',
      '$5,000 以上',
    ],
  },
  {
    name: '您最常透過哪些平台\r\n獲取美妝資訊？',
    options: [
      'Sorra.net 用家留言（正/負評）',
      'Instagram',
      'YouTube',
      '小紅書',
      'Threads',
      'Facebook',
      '美妝雜誌編輯推介',
    ],
  },
  // ver 2025 1/3 4:10
  // {
  //   name: '您最有好感的美妝護膚\r\n香港代言組合是？',
  //   options: [
  //     `盧瀚霆\r\n(Anson Lo)\r\nCharlotte Tilbury`,
  //     `陳卓賢\r\n(Ian Chan)\r\nYSL Beauty`,
  //     `呂爵安\r\n(Edan Lui)\r\nShiseido`,
  //     `李駿傑\r\n(Jeremy Lee)\r\nGuerlain`,
  //     `江𤒹生\r\n(AK)\r\nLaura Mercier`,
  //     `邱彥筒\r\n(Marf Yau)\r\nM.A.C Cosmetics`,
  //     `王家晴\r\n(Candy)\r\nNIVEA`,
  //     `魏浚笙\r\n(Jeffrey Ngai)\r\nDIOR Beauty`,
  //     `Tyson Yoshi\r\nSK-II`,
  //     `林家謙\r\nLA MER`,
  //     `梁嘉茵\r\n(Serrini)\r\nCeraVe`,
  //     `陳凱琳\r\n(Grace Chan)\r\nGlycel`,
  //     `袁澧林\r\n(Angela Yuen)\r\nChanel Beauty`,
  //     `劉俊謙\r\n(Terrance Lau)\r\nLa Mer`,
  //     `容祖兒\r\n(Joey Yung)\r\nOASIS`,
  //     `鄧麗欣\r\n(Stephy Tang)\r\nSHIMBI METHOD`,
  //     `歸綽嶢\r\n(Nancy Kwai)\r\nLACELLE`,
  //     `王嘉爾\r\n(Jackson Wang)\r\nANESSA`,
  //     `蔡思韵\r\n(Cecilia Choi)\r\nSKINVIVE® 昇光針®`,
  //     `許軼\r\n(Day)\r\nsunplay`,
  //   ],
  // },
  {
    name: '您最有好感的美妝護膚\r\n香港代言組合是？',
    options: [
      `姜濤\r\n(Keung To)\r\nDarlie`, // new
      `盧瀚霆\r\n(Anson Lo)\r\nCharlotte Tilbury`,
      `陳卓賢\r\n(Ian Chan)\r\nYSL Beauty`,
      // `呂爵安\r\n(Edan Lui)\r\nShiseido`, // removed
      `李駿傑\r\n(Jeremy Lee)\r\nGuerlain`,
      `江𤒹生\r\n(AK)\r\nLaura Mercier`,
      `邱彥筒\r\n(Marf Yau)\r\nM.A.C Cosmetics`,
      `王家晴\r\n(Candy)\r\nNIVEA`,
      `魏浚笙\r\n(Jeffrey Ngai)\r\nDIOR Beauty`,
      `Tyson Yoshi\r\nSK-II`,
      `林家謙\r\nLA MER`,
      `梁嘉茵\r\n(Serrini)\r\nCeraVe`,
      `陳凱琳\r\n(Grace Chan)\r\nGlycel`,
      `袁澧林\r\n(Angela Yuen)\r\nChanel Beauty`,
      `劉俊謙\r\n(Terrance Lau)\r\nLa Mer`,
      `容祖兒\r\n(Joey Yung)\r\nOASIS`,
      `鄧麗欣\r\n(Stephy Tang)\r\nSHIMBI METHOD`,
      `歸綽嶢\r\n(Nancy Kwai)\r\nLACELLE`,
      `王嘉爾\r\n(Jackson Wang)\r\nANESSA`,
      `蔡思韵\r\n(Cecilia Choi)\r\nSKINVIVE® 昇光針®`,
      `許軼\r\n(Day)\r\nsunplay`,
    ],
  },
  {
    name: '您最有好感的美妝護膚\r\n日韓代言組合是？',
    options: [
      `IU\r\nESTÉE LAUDER`,
      `車銀優\r\nAbib`,
      `MINGYU\r\n(SEVENTEEN)\r\nINNISFREE`,
      `張員瑛\r\n(IVE)\r\nAMUSE`,
      `允兒\r\n雪花秀`,
      `JIN\r\n(BTS)\r\nLANEIGE`,
      `宋慧喬\r\nGUERLAIN`,
      `V (BTS)\r\nTIRTIR`,
      `FELIX (Stray Kids)\r\nTAMBURINS`,
      `KARINA (aespa)\r\nChanel Beauty`,
      `GISELLE (aespa)\r\nPerfect Whip`,
      `MINA (TWICE)\r\nSK-II`,
      `NINGNING (aespa)\r\nMaybelline New York`,
      `WINTER (aespa)\r\nespoir`,
      `NAYEON (TWICE)\r\nfwee`,
      `宇田多光\r\nShiseido`,
      `有村架純\r\nPrimavista`,
      `吉野北人\r\nVisée`,
      `小松菜奈\r\nChanel Beauty`,
      `川口春奈\r\n&be`,
    ],
  },
];

export const results = [
  {
    key: 'cleaning_toner',
    name: '潔面',
    productIds: [
      37489, 2958, 18, 23, 19, 14788, 43568, 36566, 13622, 34898, 3292,
    ],
  },
  {
    key: 'makeup_remover',
    name: '卸妝',
    productIds: [275, 5781, 316, 270, 315, 38786, 43569, 291, 302, 269],
  },
  {
    key: 'toner',
    name: '爽膚及肌底液',
    productIds: [438, 464, 413, 439, 435, 31083, 34906, 13707, 20868, 35370],
  },
  {
    key: 'essence',
    name: '精華',
    productIds: [
      572, 2585, 586, 38129, 564, 29975, 38526, 35761, 3124, 43570, 36989,
    ],
  },
  {
    key: 'moisturizer',
    name: '乳液面霜',
    productIds: [
      615, 170, 205, 19235, 193, 13587, 43571, 2816, 165, 36580, 36697, 3202,
      37787, 9963, 36664,
    ],
  },
  {
    key: 'mask',
    name: '面膜',
    productIds: [
      34899, 1286, 36202, 35904, 36379, 12442, 27532, 35982, 2588, 2106, 35968,
      35908,
    ],
  },
  {
    key: 'sunscreen',
    name: '防曬',
    productIds: [
      325, 36672, 380, 369, 43574, 2687, 31080, 35219, 43623, 385, 330, 397,
      43392, 38570,
    ],
  },
  {
    key: 'basis_makeup',
    name: '底妝',
    productIds: [
      655, 751, 885, 34539, 841, 1417, 730, 706, 843, 722, 43575, 832, 1460,
      728, 35577, 1413, 2671, 3120, 37571, 43624, 40386, 1472,
    ],
  },
  {
    key: 'eye_makeup',
    name: '眼妝',
    productIds: [
      3106, 2582, 1612, 35971, 1620, 36200, 2727, 43577, 43576, 3150, 1339,
      8187, 37866, 936, 904, 2984, 903, 1622, 958,
    ],
  },
  {
    key: 'lip_cheek_makeup',
    name: '唇部及面部彩妝',
    productIds: [
      2623, 2985, 983, 2604, 36612, 34951, 8107, 43578, 35818, 37370,
    ],
  },
  {
    key: 'fragrance',
    name: '香水／香膏',
    productIds: [2037, 2028, 2029, 43580, 43625, 2027, 43579],
  },
];

export const getProductOverallRanks = (productId) => {
  const result = [];
  if (_.isNil(productId)) {
    return result;
  }
  for (var i = 0; i < results.length; i++) {
    const { key, name, productIds } = results[i];
    // const { overall } = factor;
    const rank = _.findIndex(productIds, (id) => {
      return id === productId;
    });
    if (rank >= 0) {
      result.push({
        key,
        year: 2025,
        name,
        rank: rank + 1,
        badge: `/images/beauty-award/2025/badges/${key}-${rank > 2 ? '4-10' : rank + 1}.png`,
      });
    }
  }
  return _.orderBy(result, ['rank'], ['asc']);
};
